import ListaConvidado from './ListaConvidado'

export default ListaConvidado